// =============================================================================
// web/shims/livekit-react-native-webrtc.js — WEB shim.
//
// @livekit/react-native-webrtc is a native WebRTC pod binding. It cannot load in
// a web bundle. Only the lazy-loaded call screens import it (ScreenCapturePicker-
// View), so on web this shim provides an inert component; the call feature itself
// degrades to "not available" via the shim of @livekit/react-native. Native iOS
// resolves the real package untouched.
// =============================================================================
export const ScreenCapturePickerView = function ScreenCapturePickerViewShim() {
  return null;
};

export function registerGlobals() {}

export default {
  ScreenCapturePickerView,
  registerGlobals,
};
